import { render, staticRenderFns } from "./entityFormDialog.vue?vue&type=template&id=22560bd4"
import script from "./entityFormDialog.vue?vue&type=script&lang=js"
export * from "./entityFormDialog.vue?vue&type=script&lang=js"
import style0 from "./entityFormDialog.vue?vue&type=style&index=0&id=22560bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports